import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { AIRole } from "../ai-chat-types";
import { useGetAIRoles } from "../hooks/ai-role-hooks";
import { useGetAIRoleTypes } from "../hooks/ai-role-type-hooks";

type Props = {
    selectedRoleId: string,
    onChange: (newRole: AIRole | undefined) => void
}

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const AIRoleSelector = ({ selectedRoleId, onChange }: Props) => {
    const { data: roleTypes, isFetched: roleTypesFetched } = useGetAIRoleTypes();
    const [selectedRoleTypeId, setSelectedRoleTypeId] = useState<string>(EMPTY_GUID)
    const { data: roles, isFetched: rolesFetched, refetch } = useGetAIRoles(selectedRoleTypeId);

    useEffect(() => {
        refetch();
    }, [selectedRoleTypeId])

    const handleRoleChange = (newRoleId: string) => {
        if (newRoleId === EMPTY_GUID) {
            onChange(undefined);
            return;
        }

        const role = roles.find(r => r.id == newRoleId)!;

        onChange(role);
    }

    return (
        <>            
            <Grid item xs={2}>
                <FormControl fullWidth size="small">
                    <InputLabel id="role-type-select-label">Role Type</InputLabel>
                    <Select
                        labelId="role-type-select-label"
                        label="Role Type"
                        value={selectedRoleTypeId}
                        onChange={(e) => setSelectedRoleTypeId(e.target.value)}
                    >
                        <MenuItem value={EMPTY_GUID}>All Role Types</MenuItem>
                        {roleTypesFetched && roleTypes.map(rt => <MenuItem key={rt.id} value={rt.id}>{rt.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={5}>
                <FormControl fullWidth size="small">
                    <InputLabel id="role-select-label">Role</InputLabel>
                    <Select
                        labelId="role-select-label"
                        label="Role"
                        value={selectedRoleId}
                        onChange={(e) => handleRoleChange(e.target.value)}
                    >
                        <MenuItem value={EMPTY_GUID}>No Role Selected</MenuItem>
                        {rolesFetched && roles.map(r => <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
        </>
    )
}

export default AIRoleSelector;